<template>
  <BaseModal
    :is-visible="isVisible"
    :is-archivable="false"
    :is-editable="false"
    size="lg"
    @hideModal="hideModal()"
  >
    <template #header>
      {{$t('views.promotions.create.title')}}
    </template>
    <template #body>
      <Form></Form>
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseComponents/BaseModal'
import Form from './Form'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CreateModal',
  components: {
    BaseModal,
    Form
  },
  watch: {
    created () {
      this.reset()
      this.toggleCreateModal()
    }
  },
  computed: {
    ...mapGetters({
      isVisible: 'promotions/getIsCreateModalVisible',
      created: 'promotions/getCreated'
    })
  },
  methods: {
    hideModal () {
      this.reset()
      this.toggleCreateModal()
    },
    ...mapMutations({
      reset: 'promotions/reset',
      toggleCreateModal: 'promotions/toggleCreateModal'
    })
  }
}
</script>

<style scoped>

</style>
